import React from 'react';
import { connect } from 'react-redux';
import { InfoBar } from 'ctia-ui';
import { getDeviceTitle } from 'helpers/DeviceTypeHelper';
import { getStatusTitle, isInitial } from 'helpers/RequestHelper';

const RequestPageInfoBar = ({ request }) => {
  const { status, vendor, modelName, deviceType, type } = request;

  if (!isInitial(type)) return null;

  const reqDataInfo = [
    {
      key: 'Status',
      value: getStatusTitle(status)
    },
    {
      key: 'Manufacturer',
      value: vendor
    },
    {
      key: 'Model Name/Number',
      value: modelName
    },
    {
      key: 'Device Type',
      value: getDeviceTitle(deviceType)
    }
  ];

  return <InfoBar show={!request.formSaved} data={reqDataInfo} />;
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(RequestPageInfoBar);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/RequestPageInfoBar.js